@if (downloaderService.queue.length) {
  <div class="downloader-queue">
    <div class="downloader-queue-header d-flex justify-content-between">
      <div style="line-height: 22px">
        @if (isDownloading) {
          <span>Download in corso...</span>
        }
        @if (isSuccess || isError) {
          <span>File pronto per il download</span>
        }
      </div>
      <div class="downloader-queue-actions">
        @if (listVisible) {
          <button class="btn btn-sm" type="button" (click)="hideList()">
            <fa-icon [icon]="faAngleDown"></fa-icon>
          </button>
        }
        @if (!listVisible) {
          <button class="btn btn-sm" type="button" (click)="showList()">
            <fa-icon [icon]="faAngleUp"></fa-icon>
          </button>
        }
        <button class="btn btn-sm" type="button" (click)="closeDialog()">
          <fa-icon [icon]="faTimes"></fa-icon>
        </button>
      </div>
    </div>
    @if (downloaderService.hasItems && listVisible) {
      <ul class="downloader-queue-file-list">
        @for (item of downloaderService.queue; track item) {
          <li class="downloader-queue-file d-flex justify-content-between">
            <div class="file-name" [ngClass]="{'text-danger': item.isError}">
              <button class="btn btn-sm" (click)="openFile(item)">{{item.fileName}}</button>
            </div>
            <div class="downloader-queue-icon">
              <!--[spin]="true"-->
              @if (item.isDownloading) {
                <fa-icon [icon]="faCircleNotch"></fa-icon>
              }
              @if (item.isError && !item.isDownloading) {
                <fa-icon [icon]="faTimesCircle" class="text-danger"></fa-icon>
              }
              @if (item.isSuccess && !item.isDownloading) {
                <fa-icon [icon]="faCheckCircle" class="text-success"></fa-icon>
              }
            </div>
          </li>
        }
      </ul>
    }
  </div>
}

<a #download
  [href]="sanitizeUrl(downloadUrl)"
  [download]="downloadName"
  target="_blank"
style="display:none!important"></a>
